import React from 'react';
import { MessagesSquare, Database, PhoneMissed, CalendarCheck, RefreshCcw, Building2, BarChart3, SlidersHorizontal } from 'lucide-react';

const SOLUTIONS = [
  { id: 'communication', icon: MessagesSquare, title: 'Business Communication Systems', body: 'Calls, texts, web forms, and email connected into one coordinated flow your team can see.' },
  { id: 'crm', icon: Database, title: 'CRM Architecture & Integrations', body: 'Pipelines, stages, and integrations structured so every inquiry has an owner and a status.' },
  { id: 'lead-recovery', icon: PhoneMissed, title: 'Lead Recovery & Conversion', body: 'Missed calls and new inquiries receive approved follow-up before they move on.' },
  { id: 'scheduling', icon: CalendarCheck, title: 'Appointment Scheduling', body: 'Booking workflows, confirmations, and reminders aligned with how your team schedules.' },
  { id: 'reactivation', icon: RefreshCcw, title: 'Customer Reactivation', body: 'Past leads and previous customers are invited back with approved, well-timed outreach.' },
  { id: 'multi-location', icon: Building2, title: 'Multi-Location Operations', body: 'Routing, standards, and visibility across locations, departments, and service territories.' },
  { id: 'reporting', icon: BarChart3, title: 'Reporting & Analytics', body: 'Clear reporting on inquiries, follow-up, appointments, and pipeline activity.' },
  { id: 'optimization', icon: SlidersHorizontal, title: 'Ongoing Optimization', body: 'Workflows are monitored, maintained, and refined within your agreed service scope.' },
];


export const ServicesSection = () => (
  <section id="solutions" className="yv-section yv-bg-white" data-testid="solutions-section">
    <div className="yv-container">
      <div className="yv-section-head yv-split-head">
        <div>
          <p className="yv-eyebrow">Core Solutions</p>
          <h2 className="yv-h2">Connected Infrastructure. <span className="yv-blue-ink yv-block">Built Around Your Operations.</span></h2>
        </div>
        <p className="yv-lede" data-testid="company-intro">
          YOVAI Is An Atlanta-Based Consulting And Implementation Company Founded By Yovel Esayas. We Design, Integrate, And Manage The Systems That Connect How Your Customers Reach You With How Your Team Responds, So Every Inquiry Has A Clear Next Step.
        </p>
      </div>
      <div className="yv-sol-grid">
        {SOLUTIONS.map((s, i) => {
          const Icon = s.icon;
          return (
            <article key={s.id} className="yv-sol" style={{ animationDelay: `${i * 60}ms` }} data-testid={`solution-${s.id}`}>
              <span className="yv-sol-icon"><Icon className="w-5 h-5" aria-hidden="true" /></span>
              <h3 className="yv-sol-title">{s.title}</h3>
              <p>{s.body}</p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
